import React from "react";
import { LOGO_URL } from "../data/mockCategories";

export default function SideMenu({
  isOpen,
  onClose,
  categories,
  onSelectCategory,
  onOpenDatenschutz,
}) {
  const handleSpecialOrderClick = () => {
    onClose();
    window.location.href = "https://beyzadebaklava.de/";
  };

  return (
    <>
      <div
        className={`side-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      />
      <aside className={`side-menu ${isOpen ? "show" : ""}`}>
        <div className="side-head">
          <div
            className="side-brand"
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <img
              src={LOGO_URL}
              alt="Beyzade Logo"
              style={{
                height: "75px",
                width: "auto",
                maxWidth: "200px",
                objectFit: "contain",
                filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.3))",
              }}
            />
          </div>
          <button className="side-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="side-list">
          <div className="side-label">KATEGORIEN</div>
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="side-category"
              onClick={() => {
                onSelectCategory(cat);
                onClose();
              }}
            >
              <img className="side-thumb" src={cat.image} alt={cat.title} />
              <span className="side-name">{cat.title}</span>
              <span className="side-arrow">›</span>
            </button>
          ))}

          <div className="side-label">SERVICES & INFO</div>
          <button className="side-category" onClick={handleSpecialOrderClick}>
            <span className="side-name">🎁 Sonderbestellung</span>
            <span className="side-arrow">›</span>
          </button>

          <div
            style={{ marginTop: "20px", padding: "0 8px", fontSize: "12px" }}
          >
            <button
              onClick={() => {
                onClose();
                onOpenDatenschutz();
              }}
              style={{
                background: "none",
                border: "none",
                color: "var(--muted)",
                cursor: "pointer",
                display: "block",
                marginBottom: "8px",
                padding: 0,
                font: "inherit",
              }}
            >
              Datenschutzerklärung
            </button>
            <a
              href="#impressum"
              style={{
                color: "var(--muted)",
                textDecoration: "none",
                display: "block",
              }}
            >
              Impressum
            </a>
          </div>
        </div>
      </aside>
    </>
  );
}
